import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber
  } from "../../../commonFunctions";
  
  const rp778 = {
    label: "Overdue Notice 2",
    starting: true,
    url: "rp778",
    pageLabel: "Overdue Notice 2",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Parent Branch",
            label: "Parent Branch",
            name: "parentbranch",
            description: "Enter Parent Branch"
          },
          {
            inputType: "autocomplete",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getBranchName"
              }
            },
            options: [
              {
                label:"Branch",
                value:"Branch"
              }
            ],
            //prepend:"Br.Name";
            placeHolder: "Parent Branch ",
            name: "parentbranch",
            description: "Enter Parent Branch Code"
          },
          {
            inputType: "showdata",
            data: "parentbranch",
            textcolor: "black",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            }
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
        },
        {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Product Type",
            name: "",
            description: ""
          },
          {
            inputType: "autocomplete",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getBranchName"
              }
            },
            options: [],
            //prepend:"Br.Name";
            placeHolder: "",
            name: "producttype",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Product",
            label: "Product",
            name: "Product",
            description: "Enter Product"
          },
          {
            inputType: "autocomplete",
            default: "",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            ajaxLoad: true,
            ajaxOptions: {
              value: "code",
              label: "descn",
              query: {
                dialect: "mysql",
                query: "getBranchName"
              }
            },
            options: [],
            //prepend:"Br.Name";
            placeHolder: "Product",
            name: "Product",
            description: "Enter Product"
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
        
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "As On Date",
            name: "",
            description: ""
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            placeHolder: "",
            label: "",
            name: "asondate",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Account No From-To",
            name: "",
            description: ""
          },
          {
            inputType: "text",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "amtfrom",
            description: ""
          },
          {
            inputType: "text",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "amtto",
            description: ""
          },
          
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Top No of A/Cs",
            name: "",
            description: ""
          },
          {
            inputType: "text",
            isRequired: true,
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "topnoacs",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Sanction Amount From-To",
            name: "",
            description: ""
          },
          {
            inputType: "text",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "sactionamtfrom",
            description: ""
          },
          {
            inputType: "text",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "sactionamtto",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Overdue Type",
            name: "",
            description: ""
          },
          {
            inputType: "select",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options:[
                {
                    label:"Installment Overdue",
                    value:"Installment Overdue"
                },
                {
                    label:"Expiry Overdue",
                    value:"Expiry Overdue"
                },
                {
                    label:"All",
                    value:"All"
                },
                
            ],
            placeHolder: "",
            label: "",
            name: "overduetype",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Send SMS",
            name: "sendsms",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "OD Installments From-To",
            name: "",
            description: ""
          },
          {
            inputType: "text",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "odfrom",
            description: ""
          },
          {
            inputType: "text",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "odto",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "With Zero Overdue",
            name: "zerooverdue",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Expirt Date From-To",
            name: "",
            description: ""
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            placeHolder: "",
            label: "",
            name: "fromdate",
            description: ""
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            placeHolder: "",
            label: "",
            name: "todate",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Calculate Interest",
            name: "calculateinterest",
            description: ""
          },
          {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Open Date From-To",
            name: "",
            description: ""
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            placeHolder: "",
            label: "",
            name: "openfromdate",
            description: ""
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            placeHolder: "",
            label: "",
            name: "opentodate",
            description: ""
          },

    ]
}
export default rp778